import clsx from 'clsx';
import { ReactNode, SyntheticEvent, useEffect } from 'react';

interface Props extends BaseProps {
  children?: ReactNode;
  disableBlur?: boolean;
  disableScroll?: boolean;
  open: boolean;
  onClose(event: SyntheticEvent): void;
}

export const Backdrop = (props: Props) => {
  const {
    children,
    className,
    disableBlur = false,
    onClose,
    open,
    disableScroll = true,
    ...rest
  } = props;
  const classes = useStyles();

  const renderContent = () => {
    if (!open) return;
    return (
      <div className="fixed inset-0 flex justify-center items-center z-[9997] h-full pointer-events-none children:pointer-events-auto">
        {children}
      </div>
    );
  };

  const handleClose = (event: SyntheticEvent) => {
    event.stopPropagation();

    onClose(event);
  };

  useEffect(() => {
    if (disableScroll) {
      if (open) document.body.setAttribute('style', 'overflow: hidden;');
      else document.body.removeAttribute('style');

      return () => document.body.removeAttribute('style');
    }
  }, [open, disableScroll]);

  return (
    <div role="presentation" className="flex">
      {renderContent()}
      <div
        role="presentation"
        aria-hidden
        className={clsx(
          'z-[9996]',
          className,
          { [classes.default]: !open },
          { [classes.open]: open },
          { [classes.blur]: !disableBlur }
        )}
        onClick={handleClose}
        {...rest}
      />
    </div>
  );
};

const useStyles = () => ({
  blur: 'bg-black bg-opacity-50 backdrop-blur-[1px]',
  default: 'hidden',
  open: 'fixed flex justify-center items-center h-full w-full inset-0',
});
